import { METHOD_GET } from '@yme/utils/constants';
import { serviceAPI } from '../../../../../utils/api';
import { actions } from './actions';
export const getNewsEventsArticlesRequest = (apiEndpoint, meta) => serviceAPI({
    url: apiEndpoint,
    method: METHOD_GET,
}, actions, meta);
